import React, { memo} from 'react';
import { useSelector} from 'react-redux';
import AboveTheFold from '../../components/AboveTheFold';
import PoXiaoEntertainment from '../../components/PoXiaoEntertainment';
import ServicesSwiper from '../../components/ServicesSwiper';
import OurAdvantages from '../../components/OurAdvantages';
import Cases from '../../components/Cases';

import {isNormalZhEnCss } from '../../utils';

import styles from './styles.module.scss';

const Index = memo(() => {
    const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);
    // 样式判断
    const normal = () => {
      return isNormalZhEnCss(lang, 'English') ? styles.normalen : styles.normalcn;
    };


    const desktopMobile = () => {

      return (
          <div className={normal()}>
            <div 
              className="onePage"
            >
             <AboveTheFold />
            </div>
            <div className="twoPage">
              <PoXiaoEntertainment />
            </div>
            <div 
              className="threePage"
              name={'service'} 
              id={'service'}
            >
              <ServicesSwiper />
            </div>
            <div className="fourPage">
              <OurAdvantages />
            </div>
            <div 
              className="fivesPage"
              name={'case'} 
              id={'case'}
            >
             <Cases />
            </div>
          </div>
      );
    };

    return desktopMobile();
});
export default Index;
